import React, { Fragment } from "react";
import UF_CONTENT from "../../../../nix_components/components/UF_Content";
import withRouter from "../../../../nix_components/components/withRouter";
import data_types from "../../../../nix_components/data/data_types";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import TransferDataModal from "../../../../components/modals/TransferDataModal";
import { validators } from "../../../../nix_components/data/data_validators";
import Tooltip from "@mui/material/Tooltip/Tooltip";
import { IconButton } from "@mui/material";

class PromoCodes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permission: "package",
      transferOpen: false,
      scopeCondition: false,
      loaded: false,
    };
  }

  tools = {
    transfer: () => {
      return this.state.scopeCondition ? (
        <Tooltip title={"Transfer"}>
          <IconButton onClick={() => this.setState({ transferOpen: true })}>
            <MoveUpIcon />
          </IconButton>
        </Tooltip>
      ) : null;
    },
  };

  buttons = {};

  formConfig = {
    rows: [
      [
        {
          label: "Name",
          datatype: data_types.string,
          field: "code",
        },
        {
          label: "Percentage Discount",
          datatype: data_types.number,
          field: "percentage_discount",
        },
        {
          label: "Quantity",
          datatype: data_types.number,
          field: "quantity",
        },
      ],
      [
        {
          label: "Valid from",
          field: "valid_from",
          datatype: data_types.datetime,
          defaultValue: new Date(),
          validators: [validators.isDateBeforeToday],
        },
        {
          label: "Valid to",
          field: "valid_to",
          datatype: data_types.datetime,
          defaultValue: new Date(),
          validators: [validators.isDateBeforeToday],
        },
        {
          label: "Packages",
          reference: "packages",
          datatype: data_types.reference,
          field: "packages",
          multiple: true,
        },
      ],
    ],
  };

  gridProps = {
    fields: [
      "code",
      "percentage_discount",
      "quantity",
      "times_used",
      "packages",
      "created_by",
    ],
  };

  handleBeforeAddNew = (dataItem, callback) => {
    const userData = JSON.parse(localStorage.getItem("user"));
    dataItem.event_id = global.UF.event_id;
    dataItem.created_by = userData.id;
    if (callback) {
      callback();
    }
  };

  // renderTransferDataModal = () => {
  //     return (
  //       <TransferDataModal
  //         open={this.state.transferOpen}
  //         onClose={() =>
  //           this.setState({ transferOpen: false })
  //         }
  //         table={"promo_codes"}
  //       />
  //     );
  // }

  findCurrentPermission = () => {
    const user =
      typeof localStorage.getItem("user") === "string"
        ? JSON.parse(localStorage.getItem("user"))
        : localStorage.getItem("user");
    const scopes = user.hasOwnProperty("scopes")
      ? typeof user.scopes === "string"
        ? JSON.parse(user.scopes)
        : user.scopes
      : null;
    this.state.scopeCondition =
      scopes.findIndex(
        (permission) =>
          permission.split(":")[0] === this.state.permission &&
          permission.includes("write")
      ) > -1;
    this.setState({ loaded: true });
  };

  componentDidMount() {
    this.findCurrentPermission();
  }

  render() {
    return (
      <Fragment>
        {/* {this.state.transferOpen && this.renderTransferDataModal()} */}
        <UF_CONTENT
          table="promo_codes"
          id={this.props.event_id}
          title="Promo Codes"
          permission={"package"}
          buttons={this.buttons}
          // tools={this.tools}
          export={this.state.scopeCondition}
          formConfig={this.formConfig}
          gridProps={this.gridProps}
          edit={this.state.scopeCondition}
          delete={this.state.scopeCondition}
          add={this.state.scopeCondition}
          beforeAddNew={this.handleBeforeAddNew}
        />
      </Fragment>
    );
  }
}

export default withRouter(PromoCodes);
